<div class="gameHeader">
    <!-- <button class="back leftbtn" *ngIf="backButtonStatus">                                      https://jira.skilrock.com/browse/IL-715  BackButton is not show in mobile app site .....  -->
    <button class="back leftbtn">
        <a (click)="loadBack()">
            <svg class="svgicon">
                <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
            </svg>
        </a>
    </button>
    <div class="pageIndicator">
        <div class="title">{{'dge.result' | translate}}</div>
        <div class="userinfo">
            <div class="userName">{{userInfo?.playername}}</div>
            <!-- <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div> -->
            <div class="balanceWrap" *ngIf="clientCode != 'guinee'" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
            <div class="balanceWrap" *ngIf="clientCode == 'guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(userInfo?.balance)}}"></div>
            <!-- <div class="balanceWrap" *ngIf="clientCode == 'guinee'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(userInfo?.balance)}}</span></div> -->
        </div>
    </div>
</div>
<div class="tktFilterWrap">
    <div class="sectionWrapper" *ngIf="gameList.length > 3">
        <div class="blkWrap" >
            <div class="selectWrap">
                <label for="slt-game">{{'dge.game' | translate}}</label>
                <select id="slt-game" [(ngModel)]="gameSelect" (change)="getDrawResult('select')">
                    <option value="{{item.gameCode}}" *ngFor="let item of gameList; let i = index">
                        {{'common.' + item?.gameCode | translate}}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <ul class="buttonList tablook" *ngIf="gameList.length <= 3">
        <li [ngClass]="{'active': gameSelect == item?.gameCode}" (click)="getDrawResult('select', item?.gameCode)" *ngFor="let item of gameList; let i = index">
            <button>{{'common.' + item?.gameCode | translate}}</button>
        </li>
    </ul>
</div>
<div class="resultWrap {{gameSelectInfo?.class}}">
    <div class="resultHeader">
        <div class="content">
            <figure><img src="assets/images/{{clientCode}}/gamelogo/{{gameSelectInfo?.gameIcon}}"
                    alt="{{gameSelectInfo?.gameName}}" />
            </figure>
            <div class="header">
                <div class="gameName">{{'common.' + gameSelect | translate}}</div>
                <div class="searchLabel">{{gameSelectInfo?.fromDate | date: 'MMM dd, yyyy'}} {{'common.to' | translate}}
                    {{gameSelectInfo?.toDate | date: 'MMM dd, yyyy'}}</div>
            </div>
        </div>
        <form>
            <div class="dateRangeFormWrap">
                <div class="form-group">
                    <label>{{'dge.start_date' | translate}}</label>
                    <div class="input-group date">
                        <input type="text" name="fromDate" id="fromDate" class="form-control" [(ngModel)]="fromDate"
                            ngbDatepicker #d="ngbDatepicker" placeholder="yyyy-mm-dd" readonly="readonly"
                            [maxDate]="currentDate">
                        <a class="input-group-addon btn_date" (click)="d.toggle()">
                            <svg class="svgicon icon-calendar">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-calendar"></use>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="form-group">
                    <label>{{'dge.end_date' | translate}}</label>
                    <div class="input-group date">
                        <input type="text" name="toDate" id="toDate" class="form-control" [(ngModel)]="toDate"
                            ngbDatepicker #dE="ngbDatepicker" placeholder="yyyy-mm-dd" readonly="readonly"
                            [maxDate]="currentDate" [minDate]="fromDate">
                        <a class="input-group-addon btn_date" (click)="dE.toggle()">
                            <svg class="svgicon icon-calendar">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-calendar"></use>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="buttonWrap" (click)="getDrawResult('search')">
                    <button class="btn">
                        <span class="txt">{{'dge.search' | translate}}</span>
                        <svg class="svgicon icon-search">
                            <use xlink:href="assets/images/sprite-sheet.svg#icon-search"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="resultBody">
        <div class="content r-Table">
            <div class="r-TableHead">
                <div class="r-row">
                    <div class="r-Col col1">
                        <div class="r-data">
                            <div class="title">{{'dge.draw_no' | translate}}</div>
                        </div>
                    </div>
                    <div class="r-Col col2">
                        <div class="r-data">
                            <div class="title">{{'dge.date' | translate}} &amp; {{'dge.time' | translate}}</div>
                        </div>
                    </div>
                    <div class="r-Col col3">
                        <div class="r-data">
                            <div class="title">{{'dge.result' | translate}}</div>
                            <div class="r-subDataGroup"
                                *ngIf="gameSelect=='ThaiLottery' || gameSelect=='ThaiLotteryHighFrequency'">
                                <div class="r-SubData">
                                    <div class="title1 title">{{'dge.1st_prz' | translate}}</div>
                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category1' | translate}}"> -->
                                    <!-- 1<sup>st</sup> {{'dge.cat' | translate}} -->
                                    <!-- </div> -->
                                </div>
                                <div class="r-SubData">
                                    <div class="title1 title">{{'dge.1st_3' | translate}}</div>
                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category2' | translate}}"> -->
                                    <!-- 2<sup>nd</sup> {{'dge.cat' | translate}} -->
                                    <!-- </div> -->
                                </div>
                                <div class="r-SubData">
                                    <div class="title1 title">{{'dge.lst_3' | translate}}</div>
                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category3' | translate}}"> -->
                                    <!-- 3<sup>rd</sup> {{'dge.cat' | translate}} -->
                                    <!-- </div> -->
                                </div>
                                <div class="r-SubData">
                                    <div class="title1 title">{{'dge.2_dig' | translate}}</div>
                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category4' | translate}}"> -->
                                    <!-- 4<sup>th</sup> {{'dge.cat' | translate}} -->
                                    <!-- </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="r-Col col4" *ngIf="gameSelect=='LuckySix'">
                        <div class="r-data">
                            <div class="title">{{'dge.clover_ball' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="r-TableBody">
                <div class="r-rowGroup"
                    *ngFor="let result of resultData  | paginate:{itemsPerPage: 10, currentPage:p}; let resultIndex = index;"
                    [ngClass]="{'active': checkAccord(resultIndex), 'accord': gameSelect == 'LuckySix' || gameSelect == 'TwelveByTwentyFour' || gameSelect == 'MiniRoulette' || gameSelect == 'FiveByNinety'}">
                    <div class="r-row" (click)="changeAccordStatus(resultIndex)">
                        <div class="r-Col col1">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.draw_no' | translate}}</div>
                                    <div class="detail">
                                        <div class="drawId">#{{result?.drawId}}</div>
                                        <div class="drawMultiplier"
                                            *ngIf="gameSelect == 'LuckySix' && result?.winningMultiplierInfo?.multiplierCode != 'Clear'">
                                            <img src="assets/images/flag-{{clientCode}}.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col2">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.date' | translate}} &amp; {{'dge.time' | translate}}</div>
                                    <div class="detail">
                                        <div class="date">
                                            {{changeDateFormat(result?.resultDate, false) | date: 'MMM dd, yyyy'}}
                                        </div>
                                        <div class="time">{{result?.drawTime}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect=='LuckySix'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="resultBallsWrap">
                                            <div class="ballList">
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumber(result?.winningNo); let i = index;">
                                                        <div class="ballcover" *ngIf="i < 5">
                                                            <div class="ballWrap ball-{{numberArray[0][num]?.color == '' ? 'orange' : numberArray[0][num]?.color}}"
                                                                [ngClass]="{'active clover': gameSelect == 'LuckySix' && checkClover(result?.runTimeFlagInfo, num)}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumber(result?.winningNo); let i = index;">
                                                        <div class="ballcover" *ngIf="i >= 5">
                                                            <div class="ballWrap ball-{{numberArray[0][num]?.color == '' ? 'orange' : numberArray[0][num]?.color}}"
                                                                [ngClass]="{'active clover': gameSelect == 'LuckySix' && checkClover(result?.runTimeFlagInfo, num)}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3"
                            *ngIf="gameSelect=='SuperKeno' || gameSelect=='FiveByNinety' || gameSelect=='TwelveByTwentyFour' || gameSelect == 'EightByTwentyFour' || gameSelect == 'DailyLotto' || gameSelect == 'FiveByThirtySix' || gameSelect == 'SixByFifty' || gameSelect == 'Zerotonine' || gameSelect == 'MiniRoulette'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="resultBallsWrap">
                                            <div class="ballList">
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumber(result?.winningNo); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[0][num]?.color == '' ? 'orange' : numberArray[0][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                  <div class="ball" *ngIf="gameCode == 'Zerotonine'"><span class="value">{{getMappedData(num)}}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect=='OneByTwelve'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="resultNumDetail">
                                            <div class="winSymbol">
                                                <div class="svgWrap icon-{{iconMapping[result?.winningNo]}}">
                                                    <svg class="svgicon">
                                                        <use
                                                            [attr.xlink:href]="'assets/images/fortune-sprite.svg#icon-'+iconMapping[result?.winningNo]">
                                                        </use>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="winName">{{'dge.'+iconMapping[result?.winningNo] | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect=='powerball'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="resultBallsWrap">
                                            <div class="ballList">
                                                <div class="logo" style="width: 70px;height: 35px;margin-right: 10px;">
                                                    <img src="assets/images/{{clientCode}}/gamelogo/{{gameSelectInfo?.gameIcon}}" alt="{{gameSelectInfo?.gameName}}">
                                                </div>
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumberDual(result?.powerballWinningNo, 0); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[0][num]?.color == '' ? 'orange' : numberArray[0][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="plusSign">+</div>
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumberDual(result?.powerballWinningNo, 1); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[1][num]?.color == '' ? 'orange' : numberArray[1][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="ballList">
                                                <div class="logo" style="width: 70px;height: 35px;margin-right: 10px;">
                                                    <img src="assets/images/{{clientCode}}/gamelogo/{{gameSelectInfo?.gameIcon1}}" alt="{{gameSelectInfo?.gameName}}">
                                                </div>
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumberDual(result?.powerballPlusWinningNo, 0); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[0][num]?.color == '' ? 'orange' : numberArray[0][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="plusSign">+</div>
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumberDual(result?.powerballPlusWinningNo, 1); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[1][num]?.color == '' ? 'orange' : numberArray[1][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect=='SixByFortyTwoBonusBall' || gameSelect == 'FiveByFortyNineLottoWeekly'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="resultBallsWrap">
                                            <div class="ballList">
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumberDual(result?.winningNo, 0); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[0][num]?.color == '' ? 'orange' : numberArray[0][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="plusSign">+</div>
                                                <div class="ballGroup">
                                                    <ng-container
                                                        *ngFor="let num of drawWinNumberDual(result?.winningNo, 1); let i = index;">
                                                        <div class="ballcover">
                                                            <div
                                                                class="ballWrap ball-{{numberArray[1][num]?.color == '' ? 'orange' : numberArray[1][num]?.color}}">
                                                                <div class="ball"><span class="value">{{num}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3"
                            *ngIf="gameSelect=='ThaiLottery' || gameSelect=='ThaiLotteryHighFrequency'">
                            <div class="r-data" *ngVar="thaiWinningArr(result?.winningNo) as variable">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="r-subDataGroup">
                                            <div class="r-SubData">
                                                <div class="subLabel">
                                                    <div class="title1 title">{{'dge.1st_prz' | translate}}</div>
                                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category1' | translate}}"> -->
                                                    <!-- 1<sup>st</sup> {{'dge.cat' | translate}} -->
                                                    <!-- </div> -->
                                                </div>
                                                <div class="r-subDetail">
                                                    <span
                                                        class="value">{{variable[0].split('#').join('')}}{{variable[1].split('#').join('')}}</span>
                                                </div>
                                            </div>
                                            <div class="r-SubData">
                                                <div class="subLabel">
                                                    <div class="title1 title">{{'dge.1st_3' | translate}}</div>
                                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category2' | translate}}"> -->
                                                    <!-- 2<sup>nd</sup> {{'dge.cat' | translate}} -->
                                                    <!-- </div> -->
                                                </div>
                                                <div class="r-subDetail">
                                                    <span
                                                        class="value">{{variable[2].split('#').join('')}}/{{variable[3].split('#').join('')}}</span>
                                                </div>
                                            </div>
                                            <div class="r-SubData">
                                                <div class="subLabel">
                                                    <div class="title1 title">{{'dge.lst_3' | translate}}</div>
                                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category3' | translate}}"> -->
                                                    <!-- 3<sup>rd</sup> {{'dge.cat' | translate}} -->
                                                    <!-- </div> -->
                                                </div>
                                                <div class="r-subDetail">
                                                    <span
                                                        class="value">{{variable[4].split('#').join('')}}/{{variable[5].split('#').join('')}}</span>
                                                </div>
                                            </div>
                                            <div class="r-SubData">
                                                <div class="subLabel">
                                                    <div class="title1 title">{{'dge.2_dig' | translate}}</div>
                                                    <!-- <div class="title2 title" innerHTML="{{'dge.Category4' | translate}}"> -->
                                                    <!-- 4<sup>th</sup> {{'dge.cat' | translate}} -->
                                                    <!-- </div> -->
                                                </div>
                                                <div class="r-subDetail">
                                                    <span class="value">{{variable[6].split('#').join('')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect=='TwoDMYANMAAR'">
                            <div class="r-data" *ngVar="thaiWinningArr(result?.winningNo) as variable2D">
                                <div class="r-detail">
                                    <div class="label">{{'dge.result' | translate}}</div>
                                    <div class="detail">
                                        <div class="r-subDataGroup">
                                            <div class="r-SubData">
                                                <div class="r-subDetail">
                                                    <span class="value">{{variable2D[0]}}</span>
                                                    <!-- <span class="key">{{(("2000/01/01 " + result?.drawTime | date:'a') == 'AM' ? 'dge.am' : 'dge.pm') | translate}}</span> -->
                                                    <span class="key">{{((result?.drawTime?.split(":")[0] >= eveningStartHours) ? 'dge.pm' : 'dge.am') | translate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect == 'BichoRapido'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">Result</div>
                                    <div class="detail">
                                        <div class="animal-res-block-wrap">
                                            <ng-container *ngFor="let item of drawWinNumber1(result?.winningNo); let l = index;">
                                                <div class="animal-res-block arb-{{l+1}}">
                                                    <div class="img-wrap" *ngIf="item?.name && item?.number">
                                                        <img src="./assets/images/animals/{{item?.number.toString().length == 2 ? item?.number: '0'+ item?.number}}{{item?.name}}.jpg" alt="{{item?.name}}">
                                                        <div class="num-wrap">
                                                            <div class="num">{{item?.numArray[0]}}</div>
                                                            <div class="num">{{item?.numArray[1]}}</div>
                                                            <div class="num">{{item?.numArray[2]}}</div>
                                                            <div class="num">{{item?.numArray[3]}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="desc-wrap">
                                                        <div class="ani-detail">
                                                            <div class="num">{{item?.number.toString().length == 2 ? item?.number: '0'+ item?.number}}</div>
                                                            <div class="title">{{item?.name}}</div>
                                                        </div>
                                                        <div class="realWrap">
                                                            <div class="realNum">{{item?.joinNumber[0]}}</div>
                                                            <div class="realNum">{{item?.joinNumber[1]}}</div>
                                                            <div class="realNum">{{item?.joinNumber[2]}}</div>
                                                            <div class="realNum">{{item?.joinNumber[3]}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-Col col3" *ngIf="gameSelect == 'BingoSeventyFive3'">
                          <div class="r-data">
                              <div class="r-detail">
                                  <div class="label">{{'dge.result' | translate}}</div>
                                  <div class="detail">
                                      <div class="bingoBallsSection">
                                          <ul class="balls">
                                              <li class="color{{checkResultMachineBall(num)?.machineBall}}"
                                                  *ngFor="let num of drawWinNumber(result?.winningNo); let i = index;">
                                                  <div class="ball">
                                                      <div class="value">
                                                          <span
                                                              class="symbol">{{checkResultMachineBall(num)?.str}}</span>
                                                          <span class="num">{{num}}</span>
                                                      </div>
                                                  </div>
                                              </li>
                                          </ul>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                        <div class="r-Col col4" *ngIf="gameSelect=='LuckySix'">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.clover_ball' | translate}}</div>
                                    <div class="detail">
                                        <div class="resultBallsWrap">
                                            <div class="ballList">
                                                <ng-container *ngFor="let cloverData of result?.runTimeFlagInfo;">
                                                    <div class="ballcover">
                                                        <div
                                                            class="active clover ballWrap ball-{{numberArray[0][('0'+cloverData?.ballValue).slice(-2)]?.color == '' ? 'orange' : numberArray[0][('0'+cloverData?.ballValue).slice(-2)]?.color}}">
                                                            <div class="ball"><span
                                                                    class="value">{{('0'+cloverData?.ballValue).slice(-2)}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="r-rowAccordWrap " *ngIf="gameSelect == 'LuckySix'"
                        [ngStyle]="{'display': checkAccord(resultIndex) == true ? 'block' : 'none' }">
                        <!-- Slide Toggle on accord active-->
                        <div class="r-rowAccord">
                            <div class="r-col col1">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.win_mul' | translate}}</div>
                                        <div class="detail"
                                            *ngIf="result?.winningMultiplierInfo?.multiplierCode != 'Clear'">
                                            {{'dge.' + result?.winningMultiplierInfo?.multiplierCode | translate}}
                                            ({{result?.winningMultiplierInfo?.value}}x)
                                            <span class="win">
                                                <img src="assets/images/flag-{{clientCode}}.png" />
                                            </span>
                                        </div>
                                        <div class="detail"
                                            *ngIf="result?.winningMultiplierInfo?.multiplierCode == 'Clear'">
                                            ({{result?.winningMultiplierInfo?.value}}x)
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col2">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.clover_ball' | translate}}</div>
                                        <div class="detail">
                                            <ng-container
                                                *ngFor="let cloverData of result?.runTimeFlagInfo;let k = index">
                                                {{('0'+cloverData?.ballValue).slice(-2)}}{{(k+1 != result?.runTimeFlagInfo?.length) ? ', ' : ''}}
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col3">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst_bal_col' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixFirstBallColor") | titlecase}}<span
                                                class="dot dot-{{sideBetMatchInfo(result?.sideBetMatchInfo, 'LuckySixFirstBallColor') | lowercase}}"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col4">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst_bal_val' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixFirstBallSum")}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col5">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst_bal_par' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixFirstBallEvenOdd") | titlecase}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col6">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.lst_bal_col' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixLastBallColor") | titlecase}}<span
                                                class="dot dot-{{sideBetMatchInfo(result?.sideBetMatchInfo, 'LuckySixLastBallColor') | lowercase}}"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col7">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.lst_bal_val' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixLastBallSum")}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col8">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.lst_bal_par' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixLastBallEvenOdd") | titlecase}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col9">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst5_bal_sum' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixFirstFiveBallSum")}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col10">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst5_bal_par' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "LuckySixFirstFiveMoreEvenOdd") | titlecase}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="r-col col11">
                                    <div class="r-data">
                                        <div class="r-detail">
                                            <div class="label">First 5 Ball Pattern</div>
                                            <div class="detail">Decreasing</div>
                                        </div>
                                    </div>
                                </div> -->
                        </div>
                    </div>
                    <div class="r-rowAccordWrap " *ngIf="gameSelect == 'TwelveByTwentyFour' || gameSelect == 'MiniRoulette' || gameSelect == 'FiveByNinety'"
                        [ngStyle]="{'display': checkAccord(resultIndex) == true ? 'block' : 'none' }">
                        <!-- Slide Toggle on accord active-->
                        <div class="r-rowAccord" *ngIf="gameSelect == 'TwelveByTwentyFour'">
                            <div class="r-col col1">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst_bal_col' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24FirstBallColor") | titlecase}}<span
                                                class="dot dot-{{sideBetMatchInfo(result?.sideBetMatchInfo, '12/24FirstBallColor') | lowercase}}"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col2">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst_bal_val' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24FirstBallSum")}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col3">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.fst_bal_par' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24FirstBallEvenOdd") | titlecase}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col4">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.lst_bal_col' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24LastBallColor") | titlecase}}<span
                                                class="dot dot-{{sideBetMatchInfo(result?.sideBetMatchInfo, '12/24LastBallColor') | lowercase}}"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col5">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.lst_bal_val' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24LastBallSum")}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col6">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.lst_bal_par' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24LastBallEvenOdd") | titlecase}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="r-col col7">
                                <div class="r-data">
                                    <div class="r-detail">
                                        <div class="label">{{'dge.all_bal_par' | translate}}</div>
                                        <div class="detail">
                                            {{sideBetMatchInfo(result?.sideBetMatchInfo, "12/24MoreEvenOdd") | titlecase}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="r-rowAccord" *ngIf="gameSelect == 'FiveByNinety'">
                          <div class="r-col col1">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.fst_bal_col' | translate}}</div>
                                      <div class="detail">
                                          <!-- {{sideBetMatchInfo(result?.sideBetMatchInfo, "FirstBallColor") | titlecase}} -->
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "FirstBallColor") | translate}}
                                          <span class="dot dot-{{sideBetMatchInfo(result?.sideBetMatchInfo, 'FirstBallColor') | lowercase}}"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col2">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.fst_bal_val' | translate}}</div>
                                      <div class="detail">
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "5/90FirstBallSum") | translate}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col3">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.fst_bal_par' | translate}}</div>
                                      <div class="detail">
                                          <!-- {{sideBetMatchInfo(result?.sideBetMatchInfo, "5/90FirstBallOdd/Even") | titlecase}} -->
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "5/90FirstBallOdd/Even") | lowercase | translate}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col4">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.lst_bal_col' | translate}}</div>
                                      <div class="detail">
                                          <!-- {{sideBetMatchInfo(result?.sideBetMatchInfo, "LastBallColor") | titlecase}} -->
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "LastBallColor") | translate}}
                                          <span class="dot dot-{{sideBetMatchInfo(result?.sideBetMatchInfo, 'LastBallColor') | lowercase}}"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col5">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.lst_bal_val' | translate}}</div>
                                      <div class="detail">
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "5/90LastBallSum") | translate}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col6">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.lst_bal_par' | translate}}</div>
                                      <div class="detail">
                                          <!-- {{sideBetMatchInfo(result?.sideBetMatchInfo, "5/90LastBallOdd/Even") | titlecase}} -->
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "5/90LastBallOdd/Even") | lowercase | translate}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col7">
                              <div class="r-data">
                                  <div class="r-detail">
                                      <div class="label">{{'dge.all_bal_par' | translate}}</div>
                                      <div class="detail">
                                          <!-- {{sideBetMatchInfo(result?.sideBetMatchInfo, "MoreOddEven") | titlecase}} -->
                                          {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "MoreOddEven") | lowercase | translate}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="r-col col9">
                            <div class="r-data">
                                <div class="r-detail">
                                    <div class="label">{{'dge.fst5_bal_sum' | translate}}</div>
                                    <div class="detail">
                                        {{'dge.'+sideBetMatchInfo(result?.sideBetMatchInfo, "FirstFiveBallSum") | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="text-right">
                    <pagination-controls (pageChange)="pageChange($event)" autoHide="true" previousLabel=""
                        nextLabel="">
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
                                      

                   